import { PROMPT_DOCUMENTATION_APPROVED } from '@core/const/const.PROMPT_DOCUMENTATION_APPROVED';
import { PROMPT_DOCUMENTATION_OUTPUT } from '@core/const/const.PROMPT_DOCUMENTATION_OUTPUT';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@frontend/components/ui/card';
import { Separator } from '@frontend/components/ui/separator';
import { SettingsFeatureFlag } from '@frontend/Settings/components/SettingsFeatureFlag';
import { SettingsLanguage } from '@frontend/Settings/components/SettingsLanguage';
import { SettingsPrompt } from '@frontend/Settings/components/SettingsPrompt';

interface SettingsDocumentingProps {
  isReadOnly?: boolean;
}

export function SettingsDocumenting({
  isReadOnly = false,
}: SettingsDocumentingProps) {
  return (
    <Card className="mt-12 max-w-[600px]">
      <CardHeader>
        <CardTitle>Saving new answers</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-5">
          <Separator />
          <SettingsFeatureFlag
            feature={'automatically_generate_answers'}
            title="Automatically generate answers"
            description="Let QB proactively generate answers in threads to save for later"
            isReadOnly={isReadOnly}
          />
          <Separator />
          <SettingsPrompt
            title="What answers to save"
            description="Define the types of new answers the Agent should help you save."
            promptName="prompt_documentation_approved"
            defaultPrompt={PROMPT_DOCUMENTATION_APPROVED}
            isReadOnly={isReadOnly}
          />
          <Separator />

          <SettingsPrompt
            title="Writing style"
            description="Set the tone and format for saved answers."
            promptName="prompt_documentation_output"
            defaultPrompt={PROMPT_DOCUMENTATION_OUTPUT}
            isReadOnly={isReadOnly}
          />
          <Separator />
          <SettingsLanguage isReadOnly={isReadOnly} />
        </div>
      </CardContent>
    </Card>
  );
}
